import type { SingleChoiceItem } from '@vedalib/editor/lib/elements'
import { feedbackValue } from '@vedalib/editor/lib/elements/constants'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { textToRtValue } from '@vedalib/rich-text'
import * as R from 'ramda'
import React from 'react'

import ControlItem from 'components/Editor/cource/layout/controls/ControlItem'
import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import TestElementChangeStateActions from 'components/Editor/cource/layout/controls/ElementControls/TestElementChangeState'
import Separator from 'components/Editor/cource/layout/controls/Separator'
import type { IMenuOption } from 'components/uiKit/Menu'
import { AppMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import type {
  TestSingleChoiceEditorActionsType,
  TestSingleChoiceStateType,
} from './testSingleChoiceTypes'

const genItem = (id: string): SingleChoiceItem => ({
  isValid: false,
  label: textToRtValue(''),
  value: id,
  points: 1,
  feedback: feedbackValue,
})

const ADD_ITEM_ACTION: IMenuOption<'ADD_ITEM'> = {
  icon: 'otherAdd',
  label: t('uiKit.tooltip.addAnswer'),
  value: 'ADD_ITEM',
}

const TestSingleChoiceEditorActions: TestSingleChoiceEditorActionsType = ({
  element: { value },
  onChange,
  setAppMode,
  customMode,
  mode,
  setState,
  state,
}) => {
  const isFill = mode.editorMode === AppMode.fill || customMode?.editorMode === AppMode.fill
  const isPro = mode.editorMode === AppMode.pro

  const addItem = () =>
    onChange(R.assoc('items', R.append(genItem(generateId()), value.items), value))

  return (
    <>
      {isPro && <EditableProMode customMode={customMode} mode={mode} setAppMode={setAppMode} />}
      {isPro && isFill && <Separator />}
      {isFill && <ControlItem handler={addItem} option={ADD_ITEM_ACTION} />}
      <TestElementChangeStateActions<TestSingleChoiceStateType>
        setState={setState}
        state={state}
        value={value}
      />
    </>
  )
}

export default React.memo(TestSingleChoiceEditorActions) as typeof TestSingleChoiceEditorActions
